import {AuthService, OrderService, AdumoService} from 'hasta-la-vista-middleware-api/service'
export default {

    data(){
        return {
            loading: true,
            user: {FullName: null, Email: null, MobilePhone: null},
            userObj: null,
            isGuest: true,
            saveUserData: false,
            saveNewsLetter: false,
            showFacebookPixel: false,
            paymentDetails: null,
            debitDays:[{day:15, name: "15th"},{day:25, name: "25th"},{day:30, name: "30th"}],
            debitOrderDay: null,
        }
    },

    computed: {
        adumoAPI: () => process.env.ADUMO_API
    },

    methods: {
        setUser(){
            return AuthService.user().then((user)=> {
                this.userObj = user;
                this.isGuest = user.isGuest();
                if (this.isGuest) window.location.href = '/user/login'
                if (!user.isGuest() && user.MembershipActivated === false && this.first_time) {
                    // this.cookieActive = false;
                    // this.first_time = false;
                } else {
                    // this.showUserActivation = false;
                }

                return this.userObj
            })
        },

        getSubsData() {
            let subsClubRaw = window.localStorage.getItem('subsClub');

            let subsClub = null
            if(subsClubRaw && subsClubRaw != undefined) {
                subsClub = JSON.parse(subsClubRaw)
            }

            this.subsClub = subsClub
            return subsClub
        },

        cancelSubscription() {
            window.localStorage.removeItem('subsClub');
            this.$router.push('/subscription-club')
        },

        continueToNextStep() {
            let lsItem = {
                'item': this.subsClub.item,
                'userData': this.user,
                'progress': {'currentStep': 2, 'currentStepName': "confirm-details", "currentStepUrl": "/subscribe/2", 'nextStep': 3, "nextStepName": "payment", "nextStepUrl": "/subscribe/3"}
            }

            if (this.saveUserData) {
                AuthService.storeLocalUserOrderInfo(this.user)
            }
            else if (this.user.isTemp) {
                AuthService.storeLocalUserOrderInfo(this.user, true)
            }
            else {
                // console.log("not saving User Data", this.user);
            }
            window.localStorage.setItem('subsClub', JSON.stringify(lsItem));

            this.$router.push('/subscribe/3')
        },

        faceBookPixel() {
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '1442556416455138');
          fbq('track', 'PageView');

              this.showFacebookPixel = true

              return this.showFacebookPixel;
        },

        prepAdumoDetails() {
            AdumoService.prepareSubscription({
                memberEmail: this.user.Email,
                memberName: this.user.FullName,
                vistaMemberID: this.userObj.MemberId,
                vistaSubscriptionID: this.subsClub.item.Id,
                amount: parseFloat(this.subsClub.item.PriceInCents/100),
            }).then(response => {
                const {
                    ApplicationID,
                    MerchantID,
                    MerchantReference,
                    Mode,
                    Token,
                    txtCurrencyCode,
                    ShippingCountryCode,
                } = response.data

                this.paymentDetails = {
                    Mode,
                    MerchantID,
                    ApplicationID,
                    MerchantReference,
                    Amount: parseFloat(this.subsClub.item.PriceInCents/100),
                    Token,
                    txtCurrencyCode,
                    RedirectSuccessfulURL: `${process.env.APILINK}/content/subscription?type=subPaymentSuccess`,
                    RedirectFailedURL: `${process.env.APILINK}/content/subscription?type=subPaymentFail`,
                    ShippingCountryCode,
                    sessionToken: this.userObj.UserSessionId,
                    memberID: this.userObj.MemberId,
                    email: this.user.Email,
                    firstname: this.userObj.FirstName,
                    lastname: this.userObj.LastName,
                    subscriptionType: this.subsClub.item.Description,
                    subscriptionId: this.subsClub.item.Id
                }
            })
        }
    },

    created(){
        this.loading = true;
        Promise.all([this.setUser(), this.getSubsData(), this.faceBookPixel()]).then(([user, subs, pixel])=> {

            if(this.userObj && !this.userObj.isGuest()) {
                this.user.FullName = this.userObj.FirstName + " " + this.userObj.LastName
                this.user.Email = this.userObj.Email
                this.user.MobilePhone = this.userObj.MobilePhone
                this.prepAdumoDetails()
            }
            this.debitOrderDay = this.$route.query.debitDay ? this.$route.query.debitDay : this.debitDays[0].day
            this.loading = false
        })
    },

    mounted(){
        window.scrollTo(0, 0)
        window.scroll({top: 0, left: 0})
    },

    watch: {
        paymentDetails(val) {
            return val
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/subs-club/confirm-details/confirm-details.js